// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"389":"c069ee5cb672daed","2670":"c069ee5cb672daed","5149":"71695a0aaba6382f","6459":"c069ee5cb672daed","6560":"c069ee5cb672daed","8898":"f91f9a01fad3d979"}[chunkId] + ".css";
};